import type { ParseKeys } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar } from '@/components/Avatar';
import { VideoMeetingUserStatus } from '@/types/components';
import type { VideoMeetingAttendee } from '@/types/video';

const attendeeStatus: Partial<
  Record<VideoMeetingUserStatus, { labelKey: ParseKeys; className: string }>
> = {
  [VideoMeetingUserStatus.Confirmed]: {
    labelKey: 'mail.video.detail.attendeeStatus.confirmed',
    className: 'text-successful',
  },
  [VideoMeetingUserStatus.Pending]: {
    labelKey: 'mail.video.detail.attendeeStatus.pending',
    className: 'text-subtle-foreground',
  },
  [VideoMeetingUserStatus.Declined]: {
    labelKey: 'mail.video.detail.attendeeStatus.declined',
    className: 'text-destructive',
  },
};

interface Props {
  attendee: VideoMeetingAttendee;
  index: number;
}

export const VideoAttendeeRow: React.FC<Props> = ({ attendee, index }) => {
  const { t } = useTranslation();

  const { name, description, initials, status } = attendee;
  const statusConfig = status ? attendeeStatus[status] : undefined;

  return (
    <div className="flex items-center gap-3">
      {initials && <Avatar initials={initials} index={index} />}

      <div
        className={`flex min-w-0 flex-1 flex-col ${initials ? '' : 'md:pl-4'}`}
      >
        <p className="truncate text-subhead-14 text-foreground">{name}</p>
        <p className="truncate text-caption-12 text-subtle-foreground">
          {description}
        </p>
      </div>

      {statusConfig && (
        <p
          className={`text-subhead-14 shrink-0 whitespace-nowrap ${statusConfig.className}`}
        >
          {t(statusConfig.labelKey)}
        </p>
      )}
    </div>
  );
};
